<template>
  <div class="project">
    <project-header :project="project"></project-header>

    <div class="project-gallery row">
      <div class="col-12 project-gallery__img" v-for="image in firstSection" :key="image">
        <img class="project-gallery__image" :src="`/static/images/by-wood/${image}`">
      </div>
    </div>

    <project-footer prev="/work/een" next="/work/incubes"></project-footer>
  </div>
</template>

<script>
import project from '../../mixins/project'
import projects from '../../projects'

export default {
  name: 'clean-sound',
  data () {
    return {
      project: projects.find(project => project.title === 'By Wood'),
      firstSection: [
        'by-wood-brand-mark.png',
        'by-wood-card-1.jpg',
        'by-wood-card-2.jpg',
        'by-wood-magazine.jpg',
        'by-wood-stamp-1.jpg',
        'by-wood-stamp-2.jpg',
        'by-wood-stationary.jpg',
        'by-wood-window.jpg',
        'by-wood-word-mark.png'
      ]
    }
  },
  mixins: [
    project
  ]
}
</script>

<style lang="sass">

@import "../../assets/sass/utilities/variables"
@import "../../assets/sass/utilities/mixins"

</style>



// WEBPACK FOOTER //
// ByWood.vue?27d94a9e